<template>
  <v-container class="tiles controlled-width" pa-0>
    <v-layout row wrap fill-height>
      <v-flex v-for="(tile, index) in tiles" :key="'tile_ ' + index" pa-1 xs4 md3 class="tile">
        <router-link :to="{ name: tile.routeName }">
          <tile :icon="tile.icon" :title="tile.title" :text="tile.text" />
        </router-link>
      </v-flex>
    </v-layout>

    <popup />
  </v-container>
</template>

<script>
import Tile from '@/components/base/Tile';
import Popup from '@/components/popup/Popup';

// @vuese
// Widok ustawień
// @group views
export default {
  name: 'Home',
  components: { Tile, Popup },
  data() {
    return {
      tiles: [
        {
          icon: 'mdi-account',
          title: 'Profil',
          text: 'edycja',
          routeName: 'profileConfig'
        }
      ]
    };
  }
};
</script>

<style>
.tiles {
  max-width: 800px;
}
.tiles a {
  text-decoration: none;
}
</style>
